
import React, { useState, useEffect } from 'react';
import { useForm } from '../../context/FormContext';
import { useToast } from "../../hooks/use-toast";
import FormPageContainer from './page-components/FormPageContainer';
import { useTranslation } from 'react-i18next';

interface FormPageProps {
  pageNumber: number;
  hasWorksheets?: boolean;
  documentUrls?: string[];
}

const FormPage: React.FC<FormPageProps> = ({ 
  pageNumber, 
  hasWorksheets = false, 
  documentUrls = [] 
}) => {
  const { formData } = useForm();
  const { toast } = useToast();
  const { t } = useTranslation();
  
  // Show toast notification when form has saved data on initial load
  useEffect(() => {
    if (Object.keys(formData).length > 0 && pageNumber === 1) {
      toast({
        title: t('form.savedDataToastTitle'),
        description: t('form.savedDataToastDesc'),
        duration: 5000,
      });
    }
  }, []);

  return (
    <FormPageContainer 
      pageNumber={pageNumber}
      hasWorksheets={hasWorksheets}
      documentUrls={documentUrls}
    />
  );
};

export default FormPage;
